export default "__VITE_ASSET__301a50d2__"